// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2fwSQ","messages":"Chat_messages__2Stt3","dateDivider":"Chat_dateDivider__3eO_5"};